<script lang="ts" setup>
import SkrContextMenu, { type MenuItem } from '@/components/SkrContextMenu.vue'

const props = defineProps<{
  group: GroupItem
}>()

const emit = defineEmits<{
  delete: [groupId: string]
}>()

const { t } = useI18n()
const widgetStore = useWidgetStore()

const deleteGroup = () => {
  widgetStore.setDialog(
    'groups/DialogDeleteGroup',
    {
      groupName: props.group.name,
    },
    async () => {
      if (!props.group.id) {
        return
      }
      emit('delete', props.group.id)
    }
  )
}

const copyId = () => {
  navigator.clipboard.writeText(props.group.id)
  widgetStore.createSnackbar({
    message: t('business.groups.copy_success'),
  })
}

const contextMenuItems = computed((): MenuItem[] => [
  {
    label: t('business.groups.copy'),
    icon: 'custom:copy',
    action: copyId,
  },
  {
    label: t('business.groups.delete.action_text'),
    icon: 'custom:bin',
    color: 'danger',
    action: deleteGroup,
  },
])
</script>

<template>
  <skr-context-menu :items="contextMenuItems" dense />
</template>
